import React from "react";
import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useLanguageTranslation } from "../../hooks/useLanguageTranslation";
import WaterLevels from "./WaterLevels";
import RainFallData from "./RainFallData";
import { useDispatch, useSelector } from "react-redux";
import { setReservoirsTabStr } from "../../redux/slice/sliceHome";
import { useLocation } from "react-router-dom";
import useSeo from "../../hooks/useSeo";

const ReservoirStatusPage = () => {
  const dispatch = useDispatch();
  const { getText } = useLanguageTranslation();
  const { reservoirTabs } = useSelector((state) => state.homeSlice);

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
        titleLink="/reservoir-status"
        levelTwo={false}
        levelThree={false}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                {/* <!--menu section start here--> */}
                <section className="leftmenu-hori">
                  <ul>
                    <li
                      className={
                        reservoirTabs === "Water Levels" ? "active" : ""
                      }
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setReservoirsTabStr("Water Levels"));
                        }}
                      >
                        <div className="icon icon-water-level"></div>
                        {getText("Water Levels", "जल स्तर")}
                      </a>
                    </li>
                    <li
                      className={
                        reservoirTabs === "Rain Fall Data" ? "active" : ""
                      }
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setReservoirsTabStr("Rain Fall Data"));
                        }}
                      >
                        <div className="icon icon-rain-fall"></div>
                        {getText("Rain Fall Data", "वर्षा आंकड़े")}
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>

            {reservoirTabs === "Water Levels" && <WaterLevels />}
            {reservoirTabs === "Rain Fall Data" && <RainFallData />}
          </div>
        </div>
      </div>
    </>
  );
};

export default ReservoirStatusPage;
